<template lang="pug">
	div.row
		.col-sm-6 &nbsp;
		.col-sm-6
			.app-wrapper
				.app-layout
					.app-body
						.app-content
							.app-header My App
							.app-paragraph.
								Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
							.app-paragraph.
								Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
							.app-overlay
								.app-modal
									.app-modal-close-icon
										i.la.la-times
					.app-button
</template>
<style lang="scss">
.app-wrapper {
  display: inline-block;
  width: 435px;
  position: relative;
}
.app-layout {
  background: #111;
  /*padding: 70px 20px;*/
  display: inline-block;
  border-radius: 30px;
  width: 100%;
  height: 0;
  padding-bottom: 187.5%;
  position: absolute;
  z-index: 1;
  /*width: 375px;*/
  /*height: 812px;*/
}
.app-body {
  position: absolute;
  width: 86.2%;
  left: 6.9%;
  background: #fff;
  /*height: 667px;*/
  height: 81.6%;
  top: 9.2%;
  //padding-bottom: 180.5%;
  z-index: 2;
  //top: 10%;
}
.app-content {
  background: #fff;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  overflow: hidden;
  z-index: 3;
  .app-header {
    height: 50px;
    line-height: 50px;
    width: 100%;
    background: #577ba1;
    text-align: center;
    color: #fff;
    font-size: 16px;
  }
  .app-paragraph {
    padding: 15px;
    font-size: 16px;
    margin-bottom: 30px;
  }
  .app-overlay {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 4;
  }
  .app-modal {
    background: #fff;
    position: absolute;
    width: 90%;
    height: 400px;
    top: 50%;
    left: 50%;
    margin-top: -200px;
    z-index: 5;
    margin-left: -45%;
    border-radius: 5px;
    .app-modal-close-icon {
      position: absolute;
      z-index: 6;
      background: #fafafa;
      width: 30px;
      height: 30px;
      line-height: 30px;
      margin-top: -7px;
      margin-right: -7px;
      right: 0;
      font-size: 18px;
      border-radius: 100%;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
      text-align: center;
    }
  }
}
.app-button {
  position: absolute;
  width: 12%;
  height: 0;
  padding-bottom: 12%;
  margin: 0;
  border-radius: 100%;
  bottom: 1.5%;
  left: 44%;
  background: #aaa;
  z-index: 3;
}
</style>
<script>
export default {
  name: 'AppPreview',
  data() {},
  methods: {},
};
</script>
